import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IGameWinnersService } from '@/app-modules/game-winners/game-winners-service-interface';
import { IArcadeGameWinnerViewModel } from '@/app-modules/config/models/arcade-game-winners-view-model';

@Component({
  name: 'ArcadeWinnersComponent'
})
export default class ArcadeWinnersComponent extends TombolaBaseComponent {
  private arcadeWinners: IArcadeGameWinnerViewModel[] = [];
  private sixtySecondWinnersUpdate: number = 0;
  private isLoading: boolean = false;

  private get gamesWinnersService(): IGameWinnersService {
    return this.$container.get(SERVICE_IDENTIFIERS.IGameWinnersService) as IGameWinnersService;
  }

  private async mounted() {
    this.getAndUpdateWinners();
    this.sixtySecondWinnersUpdate = window.setInterval(async () => await this.getAndUpdateWinners(), 60000);
  }

  private beforeDestroy() {
    window.clearInterval(this.sixtySecondWinnersUpdate);
  }

  private async getAndUpdateWinners() {
    try {
      this.isLoading = true;
      const resp = await this.gamesWinnersService.getArcadeWinners();
      this.arcadeWinners = resp;
    }
    finally {
      this.isLoading = false;
    }
  }

  private getPrizeMessageForWinner(winner: IArcadeGameWinnerViewModel): string {
    return `${this.$lang.game.prize.currencySymbol}${winner.prize.toFixed(2)}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game-winners/_components/arcade/arcade.winners-view.component.ts